import React from 'react';
import { ArrowLeft, AlertTriangle } from 'lucide-react';
import { useLanguage } from '../../i18n';
import { ProcessingLoader } from '../ProcessingLoader';

export const NotFoundState = ({ onBack }) => {
  const { t } = useLanguage();
  return (
    <div className="ss-card p-10 text-center space-y-4 max-w-md mx-auto mt-8" data-testid="result-not-found">
      <AlertTriangle size={28} className="text-[#E9C46A] mx-auto" />
      <h1 className="font-display font-bold text-lg text-white">{t('notFoundTitle')}</h1>
      <button onClick={onBack} className="text-sm text-white/70 hover:text-white font-mono" data-testid="result-back-dashboard">
        {t('backToDashboard')}
      </button>
    </div>
  );
};

export const LoadingState = () => (
  <div className="flex justify-center py-24" data-testid="result-loading">
    <div className="flex gap-2">
      <div className="ss-dot" />
      <div className="ss-dot" />
      <div className="ss-dot" />
    </div>
  </div>
);

export const AnalyzingState = ({ step, onBack }) => {
  const { t } = useLanguage();
  return (
    <div className="max-w-xl mx-auto space-y-4">
      <button onClick={onBack} className="flex items-center gap-1.5 text-sm text-white/55" data-testid="result-back-button">
        <ArrowLeft size={15} /> {t('backToDashboard')}
      </button>
      <ProcessingLoader currentStep={['tracking', 'analyzing', 'generating'].includes(step) ? step : 'analyzing'} />
    </div>
  );
};

export const FailedState = ({ error, onRetry }) => {
  const { t } = useLanguage();
  return (
    <div className="ss-card p-10 text-center space-y-4 max-w-md mx-auto mt-8" data-testid="result-failed">
      <AlertTriangle size={28} className="text-[#E76F7B] mx-auto" />
      <div>
        <h1 className="font-display font-bold text-lg text-white">{t('analysisFailedTitle')}</h1>
        <p className="text-xs text-white/45 font-mono mt-2 break-words">{error}</p>
      </div>
      <button onClick={onRetry} className="ss-btn-primary h-11 px-6 text-sm font-semibold" data-testid="result-retry-button">
        {t('tryAgain')}
      </button>
    </div>
  );
};
